<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item,index) in swiperList" :key="index">
        <img :src="item.image_url" @click="jumpOutside(item)"/>
      </swiper-slide>
    </swiper>
    <div class="borderBottom mt40 pb10 flex al-cn">
      <div class="commonTitle discolour" @click="routerGo('/Check-inInformation')">비즈니스통역/여행가이드/기사</div>
      <el-dropdown class="mlr40">
        <div class="el-dropdown-link">
          {{ cityName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div @click="regionClick(item)" v-for="(item,index) in regionList" :key="index">
            <el-dropdown-item>{{ item.name }}</el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <div class="el-dropdown-link">
          {{ typeName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div @click="industryClick(item)" v-for="(item,index) in industryList" :key="index">
            <el-dropdown-item>{{ item.name }}</el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
        class="table" ref="filterTable" :data="tableData" style="width: 100%"
        :header-cell-style="{backgroundColor:'#F3F4F8'}" @row-click="rowClick">
      <el-table-column label="도시">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.talentsCitys" :key="index">
            {{ item.name }}
            <span v-if="scope.row.talentsCitys && (index + 1 < scope.row.talentsCitys.length)">,</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="이름" width="180"></el-table-column>
      <el-table-column prop="gender" label="성별" width="100"></el-table-column>
      <el-table-column label="업종">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.talentsTypes" :key="index">
            {{ item.name }}
            <span v-if="scope.row.talentsTypes && (index + 1 < scope.row.talentsTypes.length)">,</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="일당"></el-table-column>
      <el-table-column prop="exp" label="근무경력" width="180"></el-table-column>
      <el-table-column prop="sketch" label="키워드" show-overflow-tooltip></el-table-column>
      <el-table-column label="클릭" width="100">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="text"
              @click="talentDetails(scope.row)">
            더보기
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="Talent-list">
      <Talent-list
          v-for="(item,index) in tableData"
          :key="index"
          :item="item"
          @detailsClick="talentDetails"/>
    </div>
    <div class="borderBottom commonTitle mt40 pb10 discolour" @click="routerGo('/enterpriseInformation')">중국업체/관광지/도매시장
    </div>
    <div class="list mtb20">
      <list-item :item="item" v-for="(item,index) in list" :key="index"></list-item>
    </div>
    <su-dialog :item="personnelDetails" v-if="personnelInformation" @close="personnelInformation = false"/>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import {areaList, talentsList, getIndustryList, getBanner, goodsList, talentsDetail} from "@/api/api";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      // 轮播图数据
      swiperList: [],
      loading: false,
      personnelInformation: false, // 人员信息弹窗
      swiperOption: {
        // 自动切换
        autoplay: {
          // 停留时间
          delay: 3000,
          // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false,
        },
        pagination: true,
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        on: {}
      },
      tableData: [
        {
          district: '上海',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          tag: '家'
        }, {
          district: '地区地区',
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          tag: '公司'
        }, {
          district: '地区地区',
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          tag: '家'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          tag: '公司'
        }],
      list: [
        {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情商品详情商品详情商品详情商品详情商品详情商品详情",
        },
        {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        }, {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        }, {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        }, {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        }, {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        }, {
          img: require("@/assets/img/jianjietopmin.jpg"),
          title: "商品名称",
          desc: "商品详情商品详情商品详情商品详情商品详情商品详情",
        },
      ],
      typeId: '', // 语种id
      typeName: '업종', // 语种
      industryList: [], // 语种列表
      cityId: '', // 城市id
      cityName: '도시', // 城市
      regionList: [], //地区列表
      personnelDetails: {}, // 人员详情
    };
  },
  created() {

  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.getBanner() // 获取轮播图数据
    this.goodsList()  // 获取商品列表
    this.talentsList() // 获取人员列表
    this.areaList() // 获取地区列表
    this.getIndustryList() // 获取语种列表
  },
  methods: {
    routerGo(path) {
      this.$router.push({path: path});
    },
    // 跳转外部
    jumpOutside(e) {
      if (e.url) {
        window.open(e.url)
      }
    },
    // 地区点击
    regionClick(e) {
      this.cityId = e.city_id
      this.cityName = e.name
      this.talentsList()
    },
    // 语种点击
    industryClick(e) {
      this.typeId = e.type_id
      this.typeName = e.name
      this.talentsList()
    },
    rowClick(row) {
      // 在这里处理行点击事件
      talentsDetail({
        talentsId: row.talents_id
      }).then(res => {
        if (res.status == 200) {
          this.personnelDetails = res.data.detail
          this.personnelInformation = true
        }
      })
    },
    // 人员详情
    talentDetails(e) {
      talentsDetail({
        talentsId: e.talents_id
      }).then(res => {
        if (res.status == 200) {
          this.personnelDetails = res.data.detail
          this.personnelInformation = true
        }
      })
    },
    // 获取商品列表
    goodsList() {
      goodsList().then(res => {
        if (res.status == 200) {
          this.list = res.data.list
        }
      })
    },
    // 获取轮播图数据
    getBanner() {
      getBanner().then(res => {
        if (res.status == 200) {
          this.swiperList = res.data.banners
          res.data.articles.forEach(item => {
            item.text = item.title
            if (item.text.length > 10) {
              item.text = item.title.substring(0, 10) + '...'
            }
          })
          this.$store.commit('setArticles', res.data.articles)
        }
      })
    },
    // 获取地区列表
    areaList() {
      areaList().then(res => {
        if (res.status == 200) {
          var list = [{value: 0, text: '전부', type_id: 0, name: '전부'}];
          this.regionList = [...list, ...res.data.list]
        }
      })
    },
    // 获取语种列表
    getIndustryList() {
      // 获取语种列表
      getIndustryList().then(res => {
        if (res.status == 200) {
          var list = [{value: 0, text: '전부', city_id: 0, name: '전부'}];
          this.industryList = [...list, ...res.data.list]
        }
      })
    },
    // 获取人才列表
    talentsList() {
      talentsList({
        typeId: this.typeId,
        cityId: this.cityId,
      }).then(res => {
        if (res.status == 200) {
          this.tableData = res.data.list
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.home {
  font-family: PingFangSC, PingFang SC;
}

.swiper-slide {
  font-size: 24px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  img {
    width: 100%;
    height: 100%;
  }

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3 {
      font-size: 40px;
      font-weight: 600;
      color: #fff;
    }
  }
}

.slide-one {
  background: url(../assets/image/laboratory.png) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

.list {
  grid-column-gap: 10px;
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
}


@media (min-width: 750px) {
  .list {
    grid-column-gap: 20px;
    grid-template-columns: calc(20% - 5px) calc(20% - 5px) calc(20% - 5px) calc(20% - 5px) calc(20% - 5px);
  }
  .Talent-list {
    display: none;
  }
}

@media (max-width: 750px) {
  .swiper-slide {
    height: 90px;
  }
  .table {
    display: none;
  }
}
</style>
